import MemCache from "../../utils/MemCache";
import { initialState } from "../store";

export default function onLogout(state, payload) {
  MemCache.clear();
  return initialState;
}
